import { Button } from "components/button/Button/Button";
import { DropdownListPortalOverlay } from "components/portal/DropdownListPortal/style";
import { Icons } from "contents/icons";
import { useEffect, useRef, useState } from "react";
import useLibraryDataStore from "store/useLibraryDataStore";
import useMoreMenuStore from "store/useMoreMenuStore";
import usePageStore from "store/usePageStore";
import { Util } from "Util";
import { Tooltip } from "../Tooltip";
import { StyledListMoreMenu } from "./style";

export const ListMoreMenu = () => {
  const [hoverBtnType, setHoverBtnType] = useState("");
  const { btnList, moreMenuStyle, setIsMoreMenuVisible } = useMoreMenuStore();
  const listMoreMenuRef = useRef<HTMLDivElement>(null);

  const { libraryData, versionData } = useLibraryDataStore();
  const { listDepthList } = usePageStore();

  const returnIcon = (type: string): keyof typeof Icons => {
    switch (type) {
      case "copy":
        return "Copy07";
      case "edit":
        return "Edit05";
      case "delete":
        return "Trash03";
      case "editDetails":
        return "Settings02";
      case "addVersion":
        return "AddList";
      case "viewLatestRun":
        return "InfoCircle";
      case "publish":
        return "Share07";
      case "move":
        return "Share06";
      default:
        return "Edit05";
    }
  };

  const onWheelHandler = () => {
    setIsMoreMenuVisible(false);
  };

  // 바깥영역 클릭 시 dropdown 닫힘 처리
  useEffect(() => {
    Util.handleObjectClose(listMoreMenuRef, setIsMoreMenuVisible);
  }, []);

  /** 수정하자 libraryData랑 versionData랑 서로 연관이 없는 경우 계속 disabled */
  const disabledAddVersionButton =
    listDepthList.length > 1
      ? versionData.publishStatus
      : libraryData.publishStatus;

  return (
    <DropdownListPortalOverlay onWheel={onWheelHandler}>
      <StyledListMoreMenu
        $left={moreMenuStyle?.left ?? 0}
        $top={moreMenuStyle?.top ?? 0}
        $height={btnList?.length * 40 || 0}
        onMouseEnter={() => {
          setIsMoreMenuVisible(true);
        }}
      >
        <div
          ref={listMoreMenuRef}
          className={`more-menu-btn ${moreMenuStyle?.isReverse && "reverse"}`}
        >
          {btnList.map(
            (value) =>
              value.isVisible !== false && (
                <div key={value.type}>
                  <Button
                    width="5.2rem"
                    color="primary"
                    type="text"
                    size="large"
                    preIcon={returnIcon(value.type)}
                    disabled={
                      (disabledAddVersionButton &&
                        value.type === "addVersion") ||
                      value.disabled
                    }
                    onClick={() => {
                      /** add Version 버튼을 누를 때만 클릭안되도록 수정 @author c_bae */
                      if (
                        disabledAddVersionButton &&
                        value.type === "addVersion"
                      ) {
                        return;
                      }

                      setIsMoreMenuVisible(false);
                      value.onClickFunction && value.onClickFunction();
                    }}
                    onMouseEnter={() => setHoverBtnType(value.type)}
                    onMouseLeave={() => {
                      setHoverBtnType("");
                    }}
                  />
                  {hoverBtnType === value.type && (
                    <Tooltip
                      direction={value.tooltip.direction}
                      label={value.tooltip.label}
                    />
                  )}
                </div>
              )
          )}
        </div>
      </StyledListMoreMenu>
    </DropdownListPortalOverlay>
  );
};
